import(/* webpackMode: "eager" */ "/home/liamto-webqam/www/apps/front/src/app/[lng]/error.tsx");
